// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  $("#st-Top").on("click", function(){
    var linkSpeed    = 800;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutExpo");
    return false;
  });
};


// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {
  const $modal = $('#sw-Youtube');
  const $content = $('#sw-Youtube_Content');

  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#sw-Youtube').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},500,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;
    });

  });


  //close
  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function(){

    $('#sw-Youtube').css({'opacity':'1'}).stop().animate({'opacity':'0'},500,'easeOutQuart',function(){
      $('#sw-Youtube').css({'display':'none'});
      $content.children('iframe').remove();
		});
  });

};



export {
  preload,
  pageTop,
  showMovie
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js